/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { enumType } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";

export enum SessionWalletCreateResponseCardsDataTypeEnum {
  "cards" = "cards"
}

/**
 * Create session wallet response data type discriminator for cards onboarding
 */

export type SessionWalletCreateResponseCardsDataType = t.TypeOf<
  typeof SessionWalletCreateResponseCardsDataType
>;
export const SessionWalletCreateResponseCardsDataType = enumType<
  SessionWalletCreateResponseCardsDataTypeEnum
>(
  SessionWalletCreateResponseCardsDataTypeEnum,
  "SessionWalletCreateResponseCardsDataType"
);
